module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-container",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('span', [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "maid-profile"
  }, [_c('img', {
    staticClass: "maid-image",
    attrs: {
      "src": "http://placecage.com/gif/25/25",
      "alt": "Maria Chiappe",
      "width": "24",
      "height": "24"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "maid-name"
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "maid-clean"
  }, [_c('span', {
    staticClass: "description-text"
  }, [_vm._v("Tipo de Limpieza:")]), _vm._v(" "), _c('span', {
    staticClass: "value-text"
  }, [_vm._v(_vm._s(_vm.typeCleaning))])]), _vm._v(" "), _c('div', {
    staticClass: "maid-actions"
  }, [_c('span', {
    staticClass: "description-text"
  }, [_vm._v("Hora: ")]), _vm._v(" "), _c('span', {
    staticClass: "value-text"
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v(" "), _c('button', {
    staticClass: "btn-maid",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.actionButton
    }
  }, [_vm._v("Editar")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38442050","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PopupMaid.vue
// module id = 739
// module chunks = 108